
import * as noneRuntime$lWeeUVNohD from '/app/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [
    "equans.ch",
    "equans.ddev.site",
    "equans.main-bvxea6i-yaugup2ejykzs.ch-1.platformsh.site",
    "kuma-evt.ch",
    "kuma.ddev.site",
    "kuma.main-bvxea6i-yaugup2ejykzs.ch-1.platformsh.site"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$lWeeUVNohD, defaults: {} }
}
        